// Variables need to have VUE_APP prefix to have a value
export default {
  env: process.env.NODE_ENV, // always "production" for deployed environments and "localhost" for local development
  reverEnv: process.env.VUE_APP_REVER_ENV, // The value will be replaced with the value injected in the "ENVIRONMENT" variable, which is one of "useast1-prod01", "useast2-preprod01" or "uswest2-devtest01"
  api: process.env.VUE_APP_API_URL,
  mobileAppId: process.env.VUE_APP_MOBILE_APP_ID,
  mixpanelToken: process.env.VUE_APP_MIXPANEL_TOKEN,
  googleClientId: process.env.VUE_APP_GOOGLE_AUTH_CLIENT_ID,
  azureAppId: process.env.VUE_APP_AZURE_APP_ID,
  recaptchaToken: process.env.VUE_APP_RECAPTCHA_TOKEN,
  optimizelyKey: process.env.VUE_APP_OPTIMIZELY_SDK_KEY,
  webAppURL: process.env.VUE_APP_WEB_URL,
  crispWebsiteId: process.env.VUE_APP_CRISP_WEBSITE_ID,
}
